export default function qs(params) {
  let urlParams = new URLSearchParams();
  for (let key in params) {
    if (Array.isArray(params[key])) {
      params[key].map(item => urlParams.append(key, item));
      continue;
    }
    urlParams.append(key, params[key]);
  }
  return urlParams.toString();
}
